import { createApi } from '@reduxjs/toolkit/query/react';
import { USER_SUGGESTIONS } from '../../utils/apiEndpoints';
import fetchQuery from '../../apiClient/fetchQuery';

export const suggesstionApi = createApi({
  reducerPath: 'suggesstionApi',
  baseQuery: fetchQuery,
  endpoints: (builder) => ({
    fetchSuggesstionResults: builder.query({
      query: ({ query }) => ({
        url: USER_SUGGESTIONS,
        params: {
          q: query,
        },
      }),
      transformResponse: (response) => ({
        suggestions: response,
      }),
    }),
  }),
});

export const { useLazyFetchSuggesstionResultsQuery } = suggesstionApi;
